import { render, staticRenderFns } from "./StudentMarksCalendarWrapper.vue?vue&type=template&id=b264b260&scoped=true"
import script from "./StudentMarksCalendarWrapper.vue?vue&type=script&lang=js"
export * from "./StudentMarksCalendarWrapper.vue?vue&type=script&lang=js"
import style0 from "./StudentMarksCalendarWrapper.vue?vue&type=style&index=0&id=b264b260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b264b260",
  null
  
)

export default component.exports